import React from 'react';
import {
  MessageSquare,
  ShoppingBag,
  Handshake,
  Briefcase,
  ArrowUpRight,
  MapPin,
} from 'lucide-react';
import './Contact.css';

const enquiries = [
  {
    icon: <MessageSquare />,
    title: 'Consultation enquiries',
    desc: 'Discuss a data, governance, or ESG initiative.',
    href: 'mailto:info@sustunetech.com?subject=Consultation%20Enquiry',
  },
  {
    icon: <ShoppingBag />,
    title: 'Sales enquiries',
    desc: 'Learn about our solutions and engagement models.',
    href: 'mailto:info@sustunetech.com?subject=Sales%20Enquiries',
  },
  {
    icon: <Handshake />,
    title: 'Partnership opportunities',
    desc: 'Join our partner ecosystem serving global organizations.',
    href: 'mailto:info@sustunetech.com?subject=Partnership%20Opportunities',
  },
  {
    icon: <Briefcase />,
    title: 'Job openings',
    desc: 'Build sustainable technology with us.',
    href: 'mailto:info@sustunetech.com?subject=Job%20Openings%20or%20Opportunities',
  },
];

const Contact = () => {
  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">Contact</span>
          <h1>We'd love to hear from you.</h1>
          <p className="page-hero-sub">
            Reach out for any enquiry — pick the closest match below and your
            email will arrive with the right subject line.
          </p>
        </div>
      </section>

      <section className="contact-band">
        <div className="wrap">
          <div className="contact-grid">
            {enquiries.map((e) => (
              <a key={e.title} href={e.href} className="contact-card">
                <span className="contact-icon">{e.icon}</span>
                <h3>{e.title}</h3>
                <p>{e.desc}</p>
                <span className="contact-go">
                  Write to us <ArrowUpRight size={16} />
                </span>
              </a>
            ))}
          </div>

          <div className="contact-general">
            <MapPin size={18} />
            <p>
              Registered office in Bengaluru, India. For any other enquiries,
              write to{' '}
              <a href="mailto:info@sustunetech.com">info@sustunetech.com</a>{' '}
              and we will revert soon.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
